

















































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import feeRow from './feeRow.vue'
import LawsuitApi from '@/api/lawsuit'
import { add, bignumber } from 'mathjs'
import { hasValue } from '@/utils/util'

@Component({
	components: {
		InfoRow,
		feeRow,
	},
})
export default class injuredFeeItem extends Vue {
	private assertList: any = []
	private rateTimeout: any = null
	private injuredTimeout: any = null
	private searchResult: Array<any> = []
	private initialRate: number | null = null
	// 判断伤残赔偿金交强险费用小计和商业险费用小计是否必填
	private itemRequired = false

	@Prop()
	private name!: any

	@Prop()
	private config!: any

	@Prop()
	private spans!: any

	@Prop()
	private form!: any

	@Prop({ default: () => {} })
	private initial!: any

	@Prop()
	private isReadonly!: boolean

	private get readonlyRow() {
		let list = (this.initial && this.initial.disabilityList) || []
		return list.map((item: any) => {
			return [
				{
					label: '伤残部位',
					value: item.disablePart,
				},
				{
					label: '评定条款',
					value: item.assessItem,
				},
				{
					label: '伤残等级',
					value: item.disableLevel,
				},
				{
					label: '系数',
					value: item.rate,
				},
			]
		})
	}

	private get disabilityList() {
		return (this.initial && this.initial.disabilityList) || []
	}

	private hasValue(val: any) {
		return hasValue(val)
	}

	private add() {
		this.$emit('addInjured')
	}

	private remove(k: number) {
		this.$emit('removeInjured', k)
		// 重新计算系数平均值
		this.$nextTick(() => {
			this.setItemRequired()
			this.initialRate = this.getRateAv()
		})
	}

	private setItemRequired() {
		let res = this.form
			.getFieldValue('injuredFeeIndex')
			.findIndex((k: number) => {
				return (
					hasValue(
						this.form.getFieldValue(
							`${this.name}.disabilityList[${k}].assessItem`
						)
					) ||
					hasValue(
						this.form.getFieldValue(`${this.name}.disabilityList[${k}].rate`)
					)
				)
			})
		this.itemRequired = res >= 0
	}

	private onSelect(selected: any, k: number) {
		// let index = this.searchResult.findIndex((item: any) => {
		// 	return item.disabilityClass === selected.label
		// })
		this.setItemRequired()
		let index = selected.key
		this.form.setFieldsValue({
			[`${this.name}.disabilityList[${k}].disablePart`]: this.searchResult[
				index
			].disabilitySite,
			[`${this.name}.disabilityList[${k}].disableLevel`]: this.searchResult[
				index
			].disabilityGrade,
		})
	}

	private handleSearch(value: string) {
		if (this.injuredTimeout) {
			clearTimeout(this.injuredTimeout)
			this.injuredTimeout = null
		}
		this.injuredTimeout = setTimeout(() => {
			if (!value) {
				return
			}
			this.assertList = []
			LawsuitApi.getDisability(value).then((res: any) => {
				this.searchResult = res.data
				this.assertList = res.data.map((item: any, index: number) => {
					return {
						value: index,
						label: item.disabilityClass,
					}
				})
			})
		}, 500)
	}

	private getRateAv() {
		let indexArr = this.form.getFieldValue('injuredFeeIndex')
		let sum: any = bignumber(0)
		let amount: number = 0
		let reg = /^\d+(\.\d+)?$/
		indexArr.forEach((k: number) => {
			let currentRatio = this.form.getFieldValue(
				`${this.name}.disabilityList[${k}].rate`
			)
			if (reg.test(currentRatio)) {
				sum = add(sum, bignumber(currentRatio))
				amount++
			}
		})
		return amount === 0 ? null : parseFloat((sum / amount).toFixed(2))
	}

	private onRateChange() {
		if (this.rateTimeout) {
			clearTimeout(this.rateTimeout)
			this.rateTimeout = null
		}
		this.rateTimeout = setTimeout(() => {
			this.setItemRequired()
			// 计算公式中的系数为各项系数之和取平均
			this.initialRate = this.getRateAv()
		}, 300)
	}

	private commercialChange() {
		this.$emit('commercialChange')
	}

	private compulsoryChange() {
		this.$emit('compulsoryChange')
	}

	private created() {
		this.setItemRequired()
	}
}
